import { StyledIconButton } from './style';

export const IconButton = ({ IconComponent, isDisabled }) => (
  <StyledIconButton isDisabled={isDisabled}>
    <IconComponent />
  </StyledIconButton>
);
